module.exports = __webpack_public_path__ + "img/cx4.81fccf1a.png";